import { useGoogleLogin } from "@react-oauth/google";
import "./googleStyle.css"
import { useState } from "react";
import { LoadingScreen } from "../LoadingScreen";
import axiosInstance from "../../../../axios/axiosInstance";
import { Button } from "@mui/material";
import { setAuthUser } from "../../../../redux/slices/AuthUser";
import { useDispatch } from "react-redux";
import { decodeToken } from "../../../../helper/decodeToken";
import GoogleIcon from '@mui/icons-material/Google';
import useNavigateBasedOnPath from "../../helper/checkPrevPath";
import { useShowAlert } from "../../../../hooks/useShowAlert";
export const LoginButton = ({
    children = "Google",
    buttonSx = {},
    endIcon = null,
    startIcon = <GoogleIcon />,
    variant = "contained",
    onSuccess,
}) => {
    const { showAlert } = useShowAlert();
    const navigateBasedOnPath = useNavigateBasedOnPath();
    const dispatch = useDispatch();
    const [accessToken, setAccessToken] = useState('');
    const googleLogin = useGoogleLogin({
        onSuccess: async tokenResponse => {
            setAccessToken(tokenResponse.access_token);
            axiosInstance.post('/user/auth/google', { accessToken: tokenResponse.access_token }).then(async (res) => {
                const token = res.data?.token;
                const { id, exp } = decodeToken(token);
                if (!token || !id || !exp) {
                    throw new Error("The server returned an invalid login session");
                }
                localStorage.setItem('token', token);
                const userResponse = await axiosInstance.get("/user/current", { skipAuthLogout: true });
                const user = userResponse.data?.user || res.data?.user || null;
                dispatch(setAuthUser({ user, exp: exp, id: id })) // set user to redux
                setAccessToken('');
                onSuccess?.(user);
                // check prev path to navigate to the correct path
                navigateBasedOnPath();
            }).catch((err) => {
                localStorage.removeItem('token');
                showAlert("error", err.response?.data?.error || err.response?.data?.message || err.message); // show error message to user
                setAccessToken(''); // reset access token to hide loading screen
            });
        },
        onError: error => {
            showAlert("error", error.message); // show error message to user
            setAccessToken('');// reset access token to hide loading screen 
        },
    });
    return (
        <>
            <Button variant={variant} startIcon={startIcon} endIcon={endIcon} sx={{
                width: "244px",
                ...buttonSx,
            }}
                onClick={googleLogin}
            >
                {children}
            </Button>
            <LoadingScreen loadingState={!!accessToken} />
        </>

    )
}
